import React, {useEffect, useState} from 'react'

import 'lazysizes';

import PaquetesMiNegocio from './Components/Organisms/Empresas/PaquetesMiNegocio'

import { CategoriesService, ChannelsService  } from "./actions/HttpCalls";
import { HttpClient } from "./actions/HttpClient";
import { URL_WEB_SERVICE_LOCAL_STORAGE } from './constants/general';

const httpClient = new HttpClient();
const categoriesService = new CategoriesService(httpClient);
const channelsService = new ChannelsService(httpClient);


function ClaroApp () {
  const [setDataCategoriasBk] = useState([])
	const [setDataChannelsBk] = useState([])

  const getValuesDefault = async () => {
    if( URL_WEB_SERVICE_LOCAL_STORAGE.indexOf("MS_FE_GUIA_CANALES") > -1 ){
      const channels = await channelsService.getChannelsItems()
      setDataChannelsBk(channels)
      const categories = await categoriesService.getCategoriesItems()
      setDataCategoriasBk(categories)
    }
	}

  useEffect(() => {
		getValuesDefault();
		// eslint-disable-next-line
	}, [])

    return (
        <>
        <PaquetesMiNegocio/>
        </>
    )
}
export default ClaroApp